module.exports = __webpack_public_path__ + "static/media/cooking.f44b0c9b.jpg";